const InvestmentRule = {
  minPay: "300",
  card: {
    text: 200,
  },
};

export default InvestmentRule;
